import React from 'react';

const Step1 = ({ 
  formData, 
  handleChange, 
  togglePassword, 
  toggleConfirm, 
  typePassword, 
  typeConfirm 
}) => {
  const { nombre, apellidoPaterno, apellidoMaterno, email, telefono, password, confirmPassword } = formData;

  return (
    <>
      <div className="mb-4">
        <h6 className="fw-bold mb-3 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-id-card me-2" style={{ color: '#4a6502' }}></i> Información del Usuario
        </h6>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Nombre(s) <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-user"></i></span>
              <input type="text" className="form-control form-control-lg" placeholder="Ej. Alejandra" name="nombre" value={nombre} onChange={handleChange} required />
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Apellido Paterno <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-user"></i></span>
              <input type="text" className="form-control form-control-lg" placeholder="García" name="apellidoPaterno" value={apellidoPaterno} onChange={handleChange} required />
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Apellido Materno <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-user"></i></span>
              <input type="text" className="form-control form-control-lg" placeholder="López" name="apellidoMaterno" value={apellidoMaterno} onChange={handleChange} required />
            </div>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h6 className="fw-bold mb-3 mt-4 text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-shield me-2" style={{ color: '#4a6502' }}></i> Acceso y Seguridad
        </h6>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Correo Electrónico <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-envelope"></i></span>
              <input type="email" className="form-control form-control-lg" placeholder="correo@ejemplo.com" name="email" value={email} onChange={handleChange} required />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Teléfono Móvil <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-mobile"></i></span>
              <input type="tel" className="form-control form-control-lg" placeholder="+52 ..." name="telefono" value={telefono} onChange={handleChange} required />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Contraseña <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-lock"></i></span>
              <input type={typePassword} className="form-control form-control-lg" placeholder="••••••••" name="password" value={password} onChange={handleChange} required />
              <button type="button" className="btn btn-sm" onClick={togglePassword}>
                {typePassword === 'text' ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
              </button>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Confirmar Contraseña <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text"><i className="fa fa-lock"></i></span>
              <input type={typeConfirm} className="form-control form-control-lg" placeholder="••••••••" name="confirmPassword" value={confirmPassword} onChange={handleChange} required />
              <button type="button" className="btn btn-sm" onClick={toggleConfirm}>
                {typeConfirm === 'text' ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step1;
